import BigCommercePaymentsFastlanePaymentMethod from './BigCommercePaymentsFastlanePaymentMethod';

export default BigCommercePaymentsFastlanePaymentMethod;
